import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Laura M.',
  role: 'Docente Técnica',
  quote: 'Ahora tengo todo el año resuelto. Entro al aula con tranquilidad y mis alumnos trabajan como técnicos.',
  initials: 'LM',
  color: 'bg-purple-500'
}, {
  name: 'Ricardo P.',
  role: 'Instructor FP',
  quote: 'Me ahorra horas de preparación. Está todo listo. Es la mejor inversión que hice para mis clases.',
  initials: 'RP',
  color: 'bg-blue-500'
}, {
  name: 'Daniela S.',
  role: 'Profesora SyH',
  quote: 'Por fin un material serio y profesional. Mis alumnos están mucho más motivados con las prácticas.',
  initials: 'DS',
  color: 'bg-orange-500'
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-174">
      <div className="container mx-auto px-4" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-177">
            Lo que otros docentes dicen...
          </h2>
          <div className="flex justify-center gap-1 text-yellow-400" data-id="element-178">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-179" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-180">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl relative" data-id="element-181">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-200" data-id="element-182" />

              <p className="text-gray-700 italic mb-6 relative z-10" data-id="element-183">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-184">
                <div className={`w-12 h-12 rounded-full ${t.color} text-white flex items-center justify-center font-bold text-lg`} data-id="element-185">
                  {t.initials}
                </div>
                <div data-id="element-186">
                  <h4 className="font-bold text-gray-900" data-id="element-187">{t.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-188">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}